import { render, staticRenderFns } from "./FolderDeleteModal.vue?vue&type=template&id=3904075e"
import script from "./FolderDeleteModal.vue?vue&type=script&lang=js"
export * from "./FolderDeleteModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/yogeshadhikari/Desktop/Projects/Scopic/picflow/picflow-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3904075e')) {
      api.createRecord('3904075e', component.options)
    } else {
      api.reload('3904075e', component.options)
    }
    module.hot.accept("./FolderDeleteModal.vue?vue&type=template&id=3904075e", function () {
      api.rerender('3904075e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/content/FolderDeleteModal.vue"
export default component.exports